module.exports = __webpack_public_path__ + "static/media/feature-2.ebc15cb9.png";